import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { getCompletedStays } from "../../profileIdentity/profileIdentity.util";
import { ElementChip } from "../../uiElements/base/ElementChip";
var GUEST_STATUS_COLOR = '#2A9D97';
var CLUB_COLOR = '#B8901A';
var TOP_PERCENT_COLOR = '#6A44C9';
// Elite memberships without a level represent licence plates or A/R accounts.
var getClubMembership = function (profile) {
    var _a;
    return (_a = profile.memberships) === null || _a === void 0 ? void 0 : _a.find(function (membership) {
        var _a;
        var level = (_a = membership.membershipLevel) === null || _a === void 0 ? void 0 : _a.trim();
        return !!level && level !== '0';
    });
};
// topPercentileAll ranks lifetime revenue from the top (0 = biggest spender); only the top 10 % get a chip.
var getTopPercent = function (percentile) { return percentile === undefined || percentile === null
    ? undefined
    : [1, 5, 10].find(function (bucket) { return percentile < bucket; }); };
var HeaderChip = function (_a) {
    var text = _a.text, color = _a.color, Icon = _a.Icon, tooltip = _a.tooltip;
    return (_jsx(ElementChip, { text: text, startIcon: _jsx(Icon, { sx: { fontSize: 15, color: color } }), borderColor: alpha(color, 0.34), backgroundColor: alpha(color, 0.06), tooltipContent: tooltip }));
};
export var hasProfileHeaderChips = function (profile) {
    var _a, _b, _c;
    return !!(((_a = profile.vipCode) === null || _a === void 0 ? void 0 : _a.trim())
        || getClubMembership(profile)
        || getTopPercent((_c = (_b = profile.smartData) === null || _b === void 0 ? void 0 : _b.revenueStats) === null || _c === void 0 ? void 0 : _c.topPercentileAll));
};
/**
 * The header's guest status, club level and Top % chips, without a list around them: the sidebar header puts them in
 * one alone, the survey reply panel next to chips of its own.
 */
var ProfileHeaderChips = function (_a) {
    var _b, _c, _d, _e;
    var profile = _a.profile;
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    var guestStatus = (_b = profile.vipCode) === null || _b === void 0 ? void 0 : _b.trim();
    var clubMembership = getClubMembership(profile);
    var revenueStats = (_c = profile.smartData) === null || _c === void 0 ? void 0 : _c.revenueStats;
    var topPercent = getTopPercent(revenueStats === null || revenueStats === void 0 ? void 0 : revenueStats.topPercentileAll);
    var staysText = t('{{count}} stays', { count: getCompletedStays(profile) });
    var lifetimeRevenue = new Intl.NumberFormat(i18n.language, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
    }).format((_d = revenueStats === null || revenueStats === void 0 ? void 0 : revenueStats.totalRevenue) !== null && _d !== void 0 ? _d : 0);
    return (_jsxs(_Fragment, { children: [guestStatus && (_jsx(HeaderChip, { text: guestStatus, color: GUEST_STATUS_COLOR, Icon: BadgeOutlinedIcon, tooltip: t('Guest status') })), clubMembership && (_jsx(HeaderChip, { text: clubMembership.membershipLevel.trim(), color: CLUB_COLOR, Icon: WorkspacePremiumOutlinedIcon, tooltip: ((_e = clubMembership.membershipProgram) === null || _e === void 0 ? void 0 : _e.trim()) || t('Club level') })), topPercent && (_jsx(HeaderChip, { text: t('Top {{percent}}%', { percent: topPercent }), color: TOP_PERCENT_COLOR, Icon: TrendingUpIcon, tooltip: "".concat(t('Lifetime revenue'), " ").concat(lifetimeRevenue, " \u00B7 ").concat(staysText) }))] }));
};
export default ProfileHeaderChips;
